import * as _hm from './_hf';
import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtPzForLoadI20rPs = (uz: _ht.uz) => {
  let _cdn = _hmFTH.vdd(uz, { bVsn: true, bDmn: false });
  return {
    tgt: 'i20rs',
    cdn: _cdn,
  };
};

export const i20z = { // メールサーバ（ドメイン共通）
  i20r: { // 年
    v0: {
      itlz: {
        _icn: '',
      },
      fldz: {
        i20ra1110s: {
          pfx: 'ホスト'
        },
        i20ra1120s: {
          pfx: 'ポート'
        },
        i20ra1210s: {
          pfx: 'ユーザ'
        },
        i20ra1220s: {
          pfx: 'パスワード'
        },
      },
    },
  },
};
